class AuthenticationService extends AbstractClass
	@registerService()
	@inject '$state',
		'$rootScope'
		'$timeout'
		'CredentialsManager'
		'ConfigurationService'
		'MessageTerminal'
		'AuthenticationRepository'
		'UserRestrictionService'
		'StrategyFactory'
		'UserInformation'
		'LockdownService'
		'LanguageService'
		'JwtService'

	@loading = false

	_setToken: (tokenData, identifier = null) =>
		if @$rootScope.isLockdown
			return

		@CredentialsManager.setAccessToken(tokenData.access_token)
		@CredentialsManager.setAccessTokenExpireTime(tokenData.expires_in)
		@CredentialsManager.setRefreshToken(tokenData.refresh_token)
		@CredentialsManager.setIdentifier(identifier) if identifier != false

	getMasterUser: ->
		@UserInformation.getMasterUser()

	getSubUser: ->
		@UserInformation.getSubUser()

	login: ({username = null, password = null, identifier = null, googleToken = null, microsoftToken = null}) ->
		if @refreshTimer?
			@$timeout.cancel(@refreshTimer)

		@CredentialsManager.clear()

		if username?
			promise = @AuthenticationRepository.getToken username, password, identifier
		else if googleToken?
			promise = @AuthenticationRepository.getTokenByGoogleToken googleToken, identifier
		else if microsoftToken?
			promise = @AuthenticationRepository.getTokenByMicrosoftToken microsoftToken, identifier
		else
			throw new Error('No credentials provided for login')

		promise
			.then (response) =>
				@_setToken(response.data)

				return @preload(response.data.access_token)
			.catch (error) =>
				console.error error

				if !@$rootScope.isLockdown
					@CredentialsManager.clear()

				throw error

	preload: (token) ->
		jwtData = @JwtService.parse(token)

		masterUserId = jwtData.sub
		subUserId = jwtData.sub_user_id || null

		(new StaticResourcePreloader())
			.loadResources(masterUserId, subUserId)
			.then =>
				@onInit()
			.catch (error) =>
				console.error error
				@CredentialsManager.clear()

				throw error

	onInit: ->
		if _.isEmpty StaticResourcePreloader.resources
			return

		@UserInformation.setResources(
			StaticResourcePreloader.resources.master_user
			StaticResourcePreloader.resources.sub_user
		)
		@CredentialsManager.setId(StaticResourcePreloader.resources.master_user.id)
		@CredentialsManager.setResourceToken StaticResourcePreloader.resources.resource_token.access_token
		@ConfigurationService.populate StaticResourcePreloader.resources.configs
		@LanguageService.setLanguages StaticResourcePreloader.resources.languages

		StaticResourcePreloader.resources = null

		@initUserRestrictions()
		@initFocusCheck()
		@initRefreshAccessToken()
		@initLockdownCheck()

	initUserRestrictions: ->
		@UserRestrictionService.register(new RelatedShopRestrictionStrategy(@StrategyFactory, @))
		@UserRestrictionService.register(new ShopRelatedShopRestrictionStrategy(@StrategyFactory, @))

	logout: (redirectToLogin = true) ->
		if @refreshTimer?
			@$timeout.cancel(@refreshTimer)

		if @$rootScope.isLockdown
			@$state.go('login')

			return

		@AuthenticationRepository
			.revokeToken()
			.finally =>
				@$rootScope.customUserCssHref = null

				identifier = @CredentialsManager.getIdentifier()
				@CredentialsManager.clear()
				@UserInformation.clear()
				@ConfigurationService.clear()

				@MessageTerminal.publish @MessageTerminal.events.LOGOUT, {identifier: identifier}

				return if not redirectToLogin

				if not _.isEmpty identifier
					@$state.go('login.identifier', {identifier: identifier})
				else
					@$state.go('login')

				return

	##
	# When browser window is in background, no js code is executed - leading to expired token in use.
	# On window focus check if we need to refresh access token
	##
	initFocusCheck: ->
		angular
			.element(window)
			.on 'focus',
				=>
					if @$rootScope.isLockdown
						return

					expireTime = @CredentialsManager.getAccessTokenExpireTime()

					if @isLoggedIn() && expireTime != null && expireTime < Date.now()
						@refreshAccessToken()

	initLockdownCheck: ->
		@LockdownService.init()

	initRefreshAccessToken: ->
		if (@refreshTimer? && !@isLoggedIn()) || !@CredentialsManager.getRefreshToken()? || @$rootScope.isLockdown
			console.warn 'No refresh token found, will not attempt to refresh access token'
			@$timeout.cancel(@refreshTimer)

			return

		expireTime = @CredentialsManager.getAccessTokenExpireTime()

		console.debug 'Access token will expire in ' +
			(expireTime - Date.now()) + 'ms on ' +
			(new Date(expireTime)).toLocaleString()

		@refreshTimer = @$timeout(
			=>
				@refreshAccessToken()
			expireTime - Date.now() - 15 * 1000
		)

	refreshAccessToken: ->
		if @loading || @$rootScope.isLockdown
			return

		@loading = true
		console.debug 'Refreshing Access Token'

		@AuthenticationRepository
			.refreshToken @CredentialsManager.getRefreshToken()
			.then (response) =>
				@_setToken(response.data)
				@initRefreshAccessToken()
			.catch =>
				@logout()
			.finally =>
				@loading = false

	isLoggedIn: ->
		return @CredentialsManager.getAccessToken() != null
